import React from 'react';
import './About.css';

function About() {
  return (
    <div className="about-page">
      <h2>About Me</h2>
      <p>
      Hello and welcome to my art page! My name is Anna Kolb, and I am attend Hope college! I have a passion for tennis, traveling, and painting.
      </p>
      <p>
      I love capturing the beauty of the outdoors, from serene landscapes to vibrant florals. One of my greatest joys in painting comes from creating animal and home portraits. There is something deeply rewarding about bringing out the character and emotion in each pet’s expression. I love seeing the joy and excitement in my customers' faces when they see their beloved pets and homes immortalized on canvas.
      </p>
      <p>
      Thank you for visiting my page! Please feel free to explore my gallery and reach out if you have any questions or would like to commission a custom piece.
      </p>
    </div>
  );
}

export default About;
